if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.sliderZoom = document.querySelector('rocket-product-media-slider-zoom')
      }

      hide() {
        super.hide();

        Array.from(this.sliderZoom.querySelectorAll('.swiper-slide')).forEach((item, index) => {
          item.classList.remove('active');
          item.classList.remove('swiper-slide-active');
        })
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);


        console.log({activeMedia});
        

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.handleActiveMediaSlider(this.getActiveIndex());
      }

      getActiveIndex() {
        let activeIndex = 0
        Array.from(this.sliderZoom.querySelectorAll('.swiper-slide')).forEach((item, index) => {
          if(item.classList.contains('active')) {
            activeIndex = index
          }
        })

        return activeIndex
      }

      handleActiveMediaSlider(activeInex) {
        if (this.sliderZoom.querySelector('.swiper')) {
          this.swiper = new Swiper(this.sliderZoom.querySelector('.swiper'), {
            loop: false,
            spaceBetween: 0,
            slidesPerView: 1,
            navigation: {
              nextEl: this?.querySelector('.swiper-button-next'),
              prevEl: this?.querySelector('.swiper-button-prev'),
            },
            mousewheel: {
              forceToAxis: true,
            },
          });

          setTimeout(() => {
            this.swiper.update()
            this.swiper.slideTo(activeInex)
          }, 100)
        }
      }
    }
  );
}
